<template>
  <div class="services" data-page="serveces">
    <div class="services__cont-dsk u-hidden--until-ipadP">
      <section
        :class="[
          'services__item',
          'services__item--left',
          currentIndex === 1 ? 'services__item--content' : '',
        ]"
        @click="changeIndex(0)"
      >
        <transition @enter="enter" @leave="leave" mode="out-in">
          <ul v-if="currentIndex === 1">
            <li>RC, steel, timber and masonry building structures design</li>
            <li>Geotechnical systems design</li>
            <li>Evaluation of static and seismic vulnerability of existing buildings</li>
            <li>Strengthening of existing buildings</li>
            <li>Design of structural supports for industrial machines</li>
          </ul>
          <p v-else>Architecture</p>
        </transition>
      </section>
      <section
        :class="[
          'services__item',
          'services__item--small',
          currentIndex === 0 ? 'services__item--architecture' : '',
          currentIndex === 1 ? 'services__item--engineering' : '',
        ]"
        @click="changeIndex(-1)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.2 102">
          <path
            class="services__icon"
            stroke="#dedede"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            fill="none"
            d="M1 35.2V101M1 101h88.2M89.2 101V35.2M89.2 35.2L45.1 1M45.1 1L1 35.2"
          />
          <path
            class="services__icon"
            stroke="#dedede"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            fill="none"
            d="M89.2 35.2L1 101M89.2 101L1 35.2M1 35.2h88.2"
          />
          <path
            class="services__reveal"
            stroke="#1d1d1b"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            fill="none"
            d="M89.2 35.2L1 101M89.2 101L1 35.2M1 35.2h88.2"
          />
          <path
            class="services__reveal"
            stroke="#1d1d1b"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            fill="none"
            d="M1 35.2V101M1 101h88.2M89.2 101V35.2M89.2 35.2L45.1 1M45.1 1L1 35.2"
          />
        </svg>
      </section>
      <section
        :class="[
          'services__item',
          'services__item--right',
          currentIndex === 0 ? 'services__item--content' : '',
        ]"
        @click="changeIndex(1)"
      >
        <transition @enter="enter" @leave="leave" mode="out-in">
          <ul v-if="currentIndex === 0">
            <li>Residential design</li>
            <li>Real estate development</li>
            <li>Commercial and public design</li>
            <li>Hotels design</li>
            <li>Interior design</li>
            <li>Light design</li>
            <li>Forniture design</li>
            <li>3d modeling and Rendering</li>
            <li>BIM technology</li>
          </ul>
          <p v-else>Engineering</p>
        </transition>
      </section>
    </div>
    <div class="services__cont-mbl u-hidden--from-ipadP">
      <QuickWords :data="{
        title: services.architecture.content.title,
        text: services.architecture.content.content,
      }"/>
      <QuickWords :data="{
        title: services.engineering.content.title,
        text: services.engineering.content.content,
      }"/>
    </div>
  </div>
</template>

<script>
import { TweenMax } from 'gsap/TweenMax';
import { qsa } from '@/scripts/utils';

import QuickWords from '@/components/QuickWords.vue';

import services from '@/assets/data/services.json';


export default {
  name: 'serveces',

  components: {
    QuickWords,
  },

  data() {
    return {
      currentIndex: -1,
      services,
    };
  },

  methods: {
    changeIndex(i) {
      this.currentIndex = i;
    },

    enter(el, done) {
      const child = qsa('li', el);

      if (child.length !== 0) {
        TweenMax.staggerFromTo(child, 0.3, {
          autoAlpha: 0,
          y: 20,
        }, {
          autoAlpha: 1,
          y: 0,
        }, 0.05, done);
      } else {
        TweenMax.fromTo(el, 0.3, {
          autoAlpha: 0,
          y: 20,
        }, {
          autoAlpha: 1,
          y: 0,
          onComplete: done,
        });
      }
    },

    leave(el, done) {
      const child = qsa('li', el);

      if (child.length !== 0) {
        TweenMax.staggerFromTo(child, 0.3, {
          autoAlpha: 1,
          y: 0,
        }, {
          autoAlpha: 0,
          y: -20,
        }, 0.05, done);
      } else {
        TweenMax.fromTo(el, 0.3, {
          autoAlpha: 1,
          y: 0,
        }, {
          autoAlpha: 0,
          y: -20,
          onComplete: done,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~sass-mq/mq";
@import '../style/colors';
@import '../style/variables';
@import '../style/functions';


.services {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  &__cont-dsk {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 60px 0;
    box-sizing: border-box;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-flow: row wrap;
  }

  &__item {
    display: inline-block;
    position: relative;
    width: 85%;
    height: 400px;

    transition: box-shadow 0.4s ease-out;
    box-shadow: 0 0 0 0 rgba(0,0,0,0);

    @include mq(mobileL) {
      width: 35%;

      &.services__item--small {
        width: 110px;
        box-shadow: 0 0 0 0 rgba(0,0,0,0) !important;
      }

      &.services__item--content {
        cursor: default;
      }
    }

    background-color: white;

    z-index: 4;
    cursor: pointer;

    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;

    @include mq(d) {
      height: 50vh;
    }

    svg {
      position: relative;
      width: 80px;
      margin: 0px;
      padding: 15px;

      fill: none;
      stroke:black;
      stroke-width: 2px;
      stroke-linecap: round;
      stroke-linejoin: round;

      path {
        transition: stroke-dashoffset 1s ease-out;
      }
    }

    p {
      margin-top: 20px;
      font-size: font-size(xl);
      -webkit-text-stroke: 1.2px $color-text;
      color: transparent;
      letter-spacing: 1px;

      transition: color 0.4s ease-out;
    }

    ul {
      max-width: 70%;

      li {
        margin-bottom: 20px;
      }
    }
  }

  & .services__item--small {
    .services__reveal:nth-child(odd) {
      stroke-dasharray: 308.3;
      stroke-dashoffset: 308.3;
    }

    .services__reveal:nth-child(even) {
      stroke-dasharray: 331.4;
      stroke-dashoffset: 331.4;
    }

    &.services__item--architecture .services__reveal {
      &:nth-child(even) {
        stroke-dasharray: 331.4;
        stroke-dashoffset: 0;
      }
    }

    &.services__item--engineering .services__reveal {
      &:nth-child(odd) {
        stroke-dasharray: 308.3;
        stroke-dashoffset: 0;
      }
    }
  }

  &__item--left:not(.services__item--content):hover {
    box-shadow: -25px 0px 85px 0px rgba(0, 0, 0, 0.1);
    z-index: 1;

    p {
      color: $color-text;
    }
  }

  &__item--right:not(.services__item--content):hover {
    box-shadow: 25px 0px 85px 0px rgba(0, 0, 0, 0.1);
    z-index: 1;

    p {
      color: $color-text;
    }
  }

  &__cont-mbl{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;

    &::v-deep {
      .quick-words {
        position: relative;
      }

      .text-block {
        width: 100%;
        overflow: hidden;
      }

      .quick-words .c-container {
        padding-bottom: 0px;
        p {
          line-height: 1.4;
        }
      }

      &:first-child .c-container {
        padding-top: 100px;
      }

      &:last-child .c-container {
        margin-bottom: 80px;
      }
    }
  }
}
</style>
